import styled, { css } from 'styled-components';
import { IconChevronLeft, IconChevronRight } from '@prisjakt/ui/icon';
import { ButtonType, IconButton } from '@prisjakt/ui/button/variants';

export const ArrowIconRight = styled(IconChevronRight).attrs(p => ({
  color: 'base300',
}))``;

export const ArrowIconLeft = styled(IconChevronLeft).attrs(p => ({
  color: 'base300',
}))``;

interface IHorizontalScrollProps {
  leftShadow?: boolean;
  rightShadow?: boolean;
}
export const HorizontalScrollContainer = styled.div<IHorizontalScrollProps>`
  height: 100%;
  width: inherit;
  overflow: hidden;
  position: relative;

  &::before,
  &::after {
    content: '';
    display: block;
    height: 100%;
    width: 0;
    max-width: 50px;
    position: absolute;
    top: 0;
    z-index: 1;
    transition: width 0.25s ease;
  }

  &::before {
    left: 0;
    background: linear-gradient(
      to right,
      ${p => p.theme.bg.primary},
      rgba(255, 255, 255, 0)
    );
  }

  &::after {
    background: linear-gradient(
      to left,
      ${p => p.theme.bg.primary},
      rgba(255, 255, 255, 0)
    );
    right: 0;
  }

  ${p =>
    p.leftShadow &&
    css`
      &::before {
        width: 8%;
      }
    `}

  ${p =>
    p.rightShadow &&
    css`
      &::after {
        width: 8%;
      }
    `}
`;

export const Inner = styled.div`
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
  overflow: -moz-scrollbars-none;
  &::-webkit-scrollbar {
    display: none;
  }

  width: inherit;
  overflow-x: scroll;
  overflow-y: hidden;
`;
export const Arrows = styled.div`
  height: 0;
  width: 0;
`;

const arrow = (hidden: boolean) => css`
  z-index: 2;
  outline: 0;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: ${p => p.theme.colors.base0};
  border-radius: 50%;
  width: 30px;
  height: 30px;
  text-align: center;
  cursor: pointer;
  transition: opacity 0.25s ease;
  opacity: 1;
  &:hover {
    background: rgba(0, 0, 0, 0.3);
  }
  &:active {
    background: rgba(0, 0, 0, 0.4);
  }
  ${hidden &&
    css`
      width: 0;
      height: 0;
      opacity: 0;
    `}
`;
interface IArrowProps {
  hidden: boolean;
}

const arrowButtonAttrs = {
  onlyIcon: true,
  type: ButtonType.TEXT,
};

export const LeftArrow = styled(IconButton).attrs(arrowButtonAttrs)<
  IArrowProps
>`
  ${p => arrow(p.hidden)}
  left: 1%;
`;

export const RightArrow = styled(IconButton).attrs(arrowButtonAttrs)<
  IArrowProps
>`
  ${p => arrow(p.hidden)}
  right: 1%;
`;

export const List = styled.ul`
  list-style: none;
  margin: 0;
  display: flex;
`;
export const Loader = styled.li`
  float: left;
  width: 100px;
  text-align: center;
`;
